import { getUxCachedProductCardItemList } from '../../graphql/product-card.2';
import type { UxGoodsCardItem } from '../../graphql/product-card_types.2';

/**
 * 상품 카드 아이템 리스트를 가져오는 함수
 *
 * @param catalogProductIdList - 조회할 상품의 카탈로그 ID 리스트
 * @returns 상품 카드 아이템 리스트
 * @throws GraphQL 요청 실패 시 에러를 throw하여 호출부에서 catch
 */
export const getProductCardItemList = async (catalogProductIdList: string[]): Promise<UxGoodsCardItem[]> => {
  const { data } = await getUxCachedProductCardItemList(
    { catalog_product_id_list: catalogProductIdList },
    { show_alert: false },
  );
  return data.getUxCachedProductCardItemList ?? [];
};
